<script>
    import { onMount, onDestroy, tick } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Header from "../components/Header.svelte";
    import { get } from "svelte/store";
    import { currentGoBack, asFilter, initialFilter } from "../stores/store";

    const savedFilter = get(asFilter);

    let startDate = savedFilter.startDate;
    let endDate = savedFilter.endDate;
    let is_status = savedFilter.is_status;
    let ASGN_EMPNO = savedFilter.ASGN_EMPNO;
    let dataList = savedFilter.dataList || [];
    let currentList = savedFilter.currentList || [];
    let currentPage = savedFilter.currentPage || 0;
    let scrollTop = savedFilter.scrollTop || 0;
    let keyword = savedFilter.keyword || "";

    let pageSize = 20;

    let scrollContainer;

    onMount(async () => {
        const fromPath = sessionStorage.getItem("fromPath");

        if (fromPath === "/Home" || !fromPath) {
            asFilter.set({ ...initialFilter });
            startDate = "";
            endDate = "";
            is_status = "1";
            ASGN_EMPNO = "1";
            dataList = [];
            currentList = [];
            currentPage = 0;
            scrollTop = 0;
        }

        if (dataList.length > 0 && scrollTop > 0) {
            await tick(); // Svelte 데이터 반영 대기

            setTimeout(() => {
                if (scrollContainer) {
                    scrollContainer.scrollTop = scrollTop;
                }
            }, 100);
        }

        if (!startDate) {
            const lastMonth = new Date();
            lastMonth.setMonth(lastMonth.getMonth() - 1);
            startDate = lastMonth.toISOString().split("T")[0];
            endDate = new Date().toISOString().split("T")[0];

            saveState(); // 초기화된 날짜 스토어에 동기화
        }

        if (dataList.length === 0) {
            getData();
        }

        currentGoBack.set(goBack);
    });

    function saveState() {
        asFilter.set({
            startDate,
            endDate,
            is_status,
            ASGN_EMPNO,
            dataList,
            currentList,
            currentPage,
            scrollTop,
            keyword,
        });
    }

    async function getData() {
        if (!startDate || !endDate) {
            alert("시작일과 종료일을 모두 선택해주세요.");
            return;
        }

        if (new Date(startDate) > new Date(endDate)) {
            alert("시작일은 종료일보다 빨라야 합니다.");
            return;
        }

        const STTUS_MAP = { "2": "I", "3": "M", "4": "T", "5": "H" };
        const STTUS = STTUS_MAP[is_status] || "";

        const response = await api.get(
            `/as?startDate=${startDate}&endDate=${endDate}&STTUS=${STTUS}&ASGN_EMPNO=${ASGN_EMPNO}&keyword=${encodeURIComponent(keyword)}`,
        );

        if (response && response.data) {
            if (JSON.stringify(response.data) !== JSON.stringify(dataList)) {
                currentPage = 0;
                dataList = response.data;
                currentList = [];
                scrollTop = 0;
                loadMore();
            }
        }
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...dataList.slice(start, end)];
        currentPage++;

        saveState();
    }

    let showScrollTop = false;

    function handleScroll(event) {
        const {
            scrollTop: currentScrollTop,
            scrollHeight,
            clientHeight,
        } = event.target;

        scrollTop = currentScrollTop;
        showScrollTop = scrollTop > 150;
        saveState();

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < dataList.length) {
                loadMore();
            }
        }
    }

    function scrollToTop() {
        if (scrollContainer) {
            scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
        }
    }


    // 필터 변경 함수들
    function setStatus(id) {
        is_status = id.split("status-")[1];
        saveState();
        getData();
    }

    function setASGN_EMPNO(id) {
        ASGN_EMPNO = id.split("status-")[1];
        saveState();
        getData();
    }

    function call(number) {
        if (number != "") {
            window.location.href = `tel:${number}`;
        }
    }

    function getHistory(bcnc_CODE) {
        push(`/AsHistoryList/${bcnc_CODE}/list`);
    }

    function goBack() {
        push("/Home");
    }

    // 페이지가 로드될 때 goBack 등록
    currentGoBack.set(goBack);

    // 페이지 벗어나면 해제
    onDestroy(() => {
        currentGoBack.set(null);
    });

    function handleKeyPress(e) {
        if (e.key === "Enter") {
            getData();
        }
    }
</script>

<Header {goBack} />

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section
    bind:this={scrollContainer}
    class="main inner main-pad-36 main-gray scroll-custom"
    style="width: 100%; position: relative; height: 100vh; overflow-y: auto"
    on:scroll={handleScroll}
>
    <div class="mobile">
        <div style="background: #FFF; padding-bottom: 5px;">
            <div class="cmn-title-left gray-width" style="padding-top: 20px;">
                <p>A/S 접수 내역</p>
            </div>


            <div class="cmn-date gray-width" style="margin-top: 15px;">
                <input
                    bind:value={startDate}
                    type="date"
                    id="startDate_m"
                    placeholder="날짜를 선택해주세요."
                    on:change={getData}
                />
                <p>~</p>
                <input
                    bind:value={endDate}
                    type="date"
                    id="endDate_m"
                    placeholder="날짜를 선택해주세요."
                    on:change={getData}
                />
            </div>

            <div class="order-status gray-width">
                <img src="resource/img/img_line.png" alt="" class="img-line" />
                <div class="status-wrap" style="height: 40px;">
                    <div
                        class="status asgn_empno"
                        class:active={ASGN_EMPNO === "1"}
                        style="margin-right: 4%; width: 50%"
                        on:click={() => setASGN_EMPNO("status-1")}
                    >
                        <div><p>전체</p></div>
                    </div>

                    <div
                        class="status asgn_empno"
                        class:active={ASGN_EMPNO === "2"}
                        style="width: 50%"
                        on:click={() => setASGN_EMPNO("status-2")}
                    >
                        <div><p>본인배정</p></div>
                    </div>
                </div>
            </div>

            <div class="order-status gray-width">
                <img src="resource/img/img_line.png" alt="" class="img-line" />
                <div class="status-wrap">
                    <div
                        class="status status_"
                        class:active={is_status === "1"}
                        style="margin-right: 4%;"
                        id="status-m-1"
                        on:click={() => setStatus("status-1")}
                    >
                        <div><p>전체</p></div>
                    </div>

                    <div
                        class="status status_"
                        class:active={is_status === "2"}
                        style="margin-right: 4%;"
                        id="status-m-2"
                        on:click={() => setStatus("status-2")}
                    >
                        <div><p>접수</p></div>
                    </div>

                    <div
                        class="status status_"
                        class:active={is_status === "3"}
                        style="margin-right: 4%;"
                        id="status-m-3"
                        on:click={() => setStatus("status-3")}
                    >
                        <div><p>처리중</p></div>
                    </div>

                    <div
                        class="status status_"
                        class:active={is_status === "5"}
                        style="margin-right: 4%;"
                        id="status-m-5"
                        on:click={() => setStatus("status-5")}
                    >
                        <div>
                            <p>
                                처리
                                <br />
                                보류
                            </p>
                        </div>
                    </div>

                    <div
                        class="status status_"
                        class:active={is_status === "4"}
                        id="status-m-4"
                        on:click={() => setStatus("status-4")}
                    >
                        <div>
                            <p>
                                처리
                                <br />
                                완료
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="cmn-btn cmn-btn-red"
                style="width: 90%; margin: 15px auto;"
            >
                <input
                    type="text"
                    bind:value={keyword}
                    style="border: 1px solid rgb(204, 204, 204); border-radius: 4px; width:100%; height: 40px; padding:0px 10px; box-sizing: border-box; "
                    placeholder="거래처명을 입력해주세요."
                    on:keypress={handleKeyPress}
                />
            </div>

            <div
                class="cmn-btn cmn-btn-red"
                style="width: 90%; margin: 15px auto;"
            >
                <button on:click={getData}>조회하기</button>
            </div>
        </div>

        <div id="item-list_m">
            {#if currentList.length > 0}
                {#each currentList as data}
                    <div style="margin-top: 15px; background: #FFF;">
                        <div class="gray-width">
                            <div class="cart-order-list">
                                <div class="order-dtl">
                                    <p>
                                        {data.rcept_DE
                                            .replace(/\.\d+$/, "")
                                            .replaceAll("-", ".")}
                                    </p>
                                    <div
                                        class="order-dtl-in"
                                        on:click={() => {
                                            saveState();
                                            push(
                                                `/AsDtl/${data.rcept_NO}/${data.rcept_SN}`,
                                            );
                                        }}
                                    >
                                        <p>내역 상세</p>
                                        <img
                                            src="resource/img/ico_arrow_right.png"
                                            alt=""
                                        />
                                    </div>
                                </div>

                                <ul>
                                    <li>
                                        <div class="list-in">
                                            <p class="list-title">거래처명</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p
                                                on:click={() => {
                                                    getHistory(data.bcnc_CODE);
                                                }}
                                            >
                                                {data.bcnc_NM ?? ""}
                                            </p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">접수내용</p>
                                        </div>
                                        <div class="list-in">
                                            <!-- prettier-ignore -->
                                            <textarea
                                                style="width:100%; height:87px"
                                                readonly
                                            >{data.rcept_CN ?? ""}</textarea>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                {/each}
            {:else}
                <!-- <p>검색 결과가 없습니다.</p> -->

                <div class="empty-container">
                    <div class="empty-icon">
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/7486/7486744.png"
                            alt=""
                            onerror="this.src='https://cdn-icons-png.flaticon.com/512/7486/7486744.png'"
                        />
                    </div>
                    <p class="empty-title">검색 결과가 없습니다</p>
                    <p class="empty-desc">조회 조건을 다시 확인해 주세요.</p>
                </div>
            {/if}
        </div>
    </div>
    <!-- 우측 하단 플로팅 맨위로 버튼 -->
    {#if showScrollTop}
        <button class="scroll-top-btn" on:click={scrollToTop} aria-label="맨위로 이동">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="18 15 12 9 6 15"/>
            </svg>
            <span>TOP</span>
        </button>
    {/if}
</section>

<style>
    p {
        white-space: unset;
    }

    .list-in_ {
        border-bottom: 1px solid;
    }
    .status.active {
        background-color: #2d3c48 !important;
    }
    .status.active p {
        color: #fff !important;
    }
    /* Empty State 컨테이너: 중앙 정렬 및 여백 */
    .empty-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 50px 20px;
        text-align: center;
    }

    /* 아이콘을 감싸는 동그란 배경 */
    .empty-icon {
        width: 100px;
        height: 100px;
        background-color: #f8f9fa;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
    }

    /* 이미지 크기 강제 고정 (이게 제일 중요!) */
    .empty-icon img {
        width: 60px !important;
        height: auto;
        opacity: 0.5;
    }

    .empty-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin: 0 0 10px 0;
    }

    .empty-desc {
        font-size: 14px;
        color: #999;
        margin: 0;
    }


    /* 플로팅 맨위로 버튼 */
    .scroll-top-btn {
        position: fixed;
        bottom: 24px;
        right: 20px;
        z-index: 99999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: #1E293B;
        color: #FFFFFF;
        border: 2px solid #334155;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .scroll-top-btn span {
        font-size: 10px;
        font-weight: 800;
        margin-top: -2px;
        letter-spacing: 0.5px;
    }
    .scroll-top-btn:hover {
        background: #2563EB;
        border-color: #60A5FA;
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(37, 99, 235, 0.4);
    }
</style>
